import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '../../../services/auth/auth';
import { UserTallCard } from '../../shared/cards/userTallCard';
import { LoadText } from '../../shared/load/loadText';
import { Query } from '../../shared/view/query';

import styles from './userList.module.css'

/**
 * @param {Object} props
 * @param {string} props.actionText Text to show on the primary button on the user card
 * @param {boolean} [props.disabledArchived=false] Should archived results be disabled
 * @param {((u) => void)|null} [props.onSelect=null] Custom callback for the primary button. Defaults to link
 */
export const UserList = ({
    actionText = 'View',
    disabledArchived = false,
    onSelect = null,
    ...props
}) => {

    const navigate = useNavigate();

    const onUserSelect = (u) => {
        if (onSelect === null)
            navigate('/users/' + u.id);
        else
            onSelect(u);
    }

    const loadingDataSet = () => [...new Array(8)].map(r => ({
        id: Math.random(),
        hasProfilePhoto: false
    }))
    
    return <div>
        <Query
            queryParamPrefix=''
            singleResourceName='User'
            pluralResourceName='Users'
            nameFunction={r => r.name}
            restEndpoint='/users'
            listUrl='/users'
            actions={[]}
            maxResults={24}
            {...props}
        >{
            ({loading, rawData, getData}) => (<div className={styles.UserList}>
                {(loading ? loadingDataSet() : rawData).map(u => <React.Fragment key={u.id}>
                    <UserTallCard 
                        data={u}
                        loading={loading}
                        actionText={actionText}
                        disabled={disabledArchived && u.archived}
                        onSelect={() => onUserSelect(u)}
                    />
                </React.Fragment>)}
            </div>)
        }</Query>


    </div>
}